 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		68: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		68: 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"buybox~collections~collections-mobile~fulfillment~paint-reorder~paint-reorder-mobile~pep~pep-mobile~~45c9a216","1":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~or~ddb78501","2":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~pa~46fe826e","3":"browse-and-search~browse-and-search-mobile~buybox~collections~collections-mobile~media-gallery-overl~de52b3ab","4":"browse-and-search~browse-and-search-mobile~compare~orange-lens~product-mobile~vendor-collections~ven~4e47053e","5":"media-gallery-filmstrip-mobile~media-gallery-overlay~media-gallery-overlay-mobile~product-mobile","6":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile~write-a-review-form","7":"BuyItAgainTypeaheadPreWrapper","8":"buybox~fulfillment~super-sku","9":"buybox~promotion-products-lazy~quick-view","10":"media-gallery-overlay~media-gallery-overlay-mobile~overlay","11":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","12":"ratings-and-reviews~ratings-and-reviews-mobile~write-a-review-form","13":"add-to-list-drawer~orange-lens","14":"bath-renovation~consumer-card-messaging","15":"compare~orange-lens","16":"media-gallery-overlay~media-gallery-overlay-mobile","18":"StoreLayout","19":"add-to-list-drawer","20":"aisle-bay","21":"augmented-reality","22":"bath-renovation","23":"breadcrumbs","24":"browse-and-search","25":"browse-and-search-mobile","26":"buybox","27":"calculator-pipcalculator","28":"collections","29":"collections-mobile","30":"compare","31":"consumer-card-messaging","32":"customer-image-overlay","33":"drawer","34":"emt-generated-content","35":"emt-links","36":"fulfillment","37":"global-custom-configurator","38":"hammerjs","40":"home","41":"magic-apron","42":"measurement-guide","43":"measurement-guide-overlay-content","44":"media-gallery-filmstrip-mobile","45":"media-gallery-overlay","46":"media-gallery-overlay-mobile","47":"message-types","48":"orange-lens","49":"order-sample","50":"order-sample-drawer","51":"overlay","52":"paint-reorder","53":"paint-reorder-mobile","54":"pep","55":"pep-mobile","56":"product","57":"product-mobile","58":"product-overview","59":"promotion-products-lazy","60":"question","61":"questions-and-answers","62":"quick-view","63":"ratings-and-reviews","64":"ratings-and-reviews-desktop","65":"ratings-and-reviews-mobile","66":"results","67":"returns-messaging","69":"share-to-email-overlay","70":"share-to-pinterest-overlay","71":"size-guide-overlay","72":"specifications","73":"stylequiz","74":"super-sku","75":"vendor-collection-products","76":"vendor-collections","77":"vendor-collections-mobile","79":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"2e28bfd49566f2b11bd8","1":"da5175fb6a46776b3bd3","2":"8b1749d6fb4ece51940d","3":"bb9a9c39909ba994f4b5","4":"186186882e1d0e425f45","5":"691bfcb2ed8c2fe21788","6":"6f1646cb9d54951860b1","7":"9cf5449bba75db5264a9","8":"dc1721afe89d4f69da64","9":"f7143f1846c52914cbc7","10":"0419507b3460a79584cf","11":"8efdaae24bee98c9dd4f","12":"6607d980d2e2c48c652b","13":"d8cddd6c525ba881d852","14":"79a5144f6d8f2c90774d","15":"096ad0e7991deb0d8fb5","16":"15e01b09695eb828d880","17":"eb4c673ee83738006068","18":"8845b0cbd88e46e68145","19":"b05aef10903b32df0e8a","20":"d7a54fe86571e9c51f5d","21":"b6da7cf83e83c40dd596","22":"d316e62dcfa08d2becd1","23":"9ebcafcaed3676246060","24":"24d1d3461f234defa218","25":"b07b93447796c80d224e","26":"0a391ff212dd52f74579","27":"a34f09868ab2fed2c744","28":"08ce21db20c30644b289","29":"5d9c2ad15de8d4a09e54","30":"da51c96f631f48cd03f7","31":"aadf686d7cd171035522","32":"0c561e93d76955cfa5ad","33":"7708c5fda947661f0e8a","34":"cd6a1eb4e973697d4247","35":"b1d1ea85103765e44237","36":"725501a76c1917158163","37":"10693c8663f3552bb293","38":"638e2bd4dfb728c32121","40":"071961b6524c4c3e757c","41":"4a54136f0d7d490642e1","42":"b721c7612109b4612d47","43":"df1a1bb3ae7eac0d3759","44":"3838f37d77673c240a98","45":"a82c3b7017cdc0907582","46":"06db1dcb6a8984a07438","47":"bf5d9d9fc4e47d8ff7ee","48":"eb55fc34cab8a76df9b7","49":"b9c8ba5a17b41c3b85c9","50":"a3f86b9a5ce6b0cc74f3","51":"5d538f74d3c884426bcd","52":"f878971a4b7092d2b0b2","53":"630161d67a0e0a8e10c4","54":"d37c47fe518f07a56f53","55":"e4fcdd46ba93c92af388","56":"f7e3adf467f9bb7743f7","57":"c33adf8003b8f26b95a3","58":"176fb9a663197468540e","59":"e50a0cdfaa83b970b66b","60":"7872385f51bb06827d0a","61":"d3165b5960e57f9895e9","62":"2fe98904326e6b61f535","63":"dc707e1fef598dee6598","64":"261d3546ec1f2af98724","65":"9b19e7716739551f8a18","66":"0944fbf38389e6989e92","67":"4f6396c869e905904fce","69":"a74c3a49ca6c5d379e57","70":"3b05503d30d13d64bd79","71":"c356299f3f2b2a405a7a","72":"416dd7bf360bb05bb49d","73":"02c18e2fc7c15677f1f1","74":"b8e8be22e11051cd003f","75":"68a45d26a23f12cf2776","76":"86e532b46c8bda6908e4","77":"8877a8d69382d24094f5","79":"b7c48b87d721db48d66f","80":"810dc27fcc4ff8f06d8d","81":"3aff5b0c100df47bb79f","82":"83dd25b3ed3bbcfb1bb9","83":"b155bb5759821d3ab231"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1,"3":1,"5":1,"6":1,"8":1,"9":1,"10":1,"11":1,"12":1,"15":1,"16":1,"17":1,"20":1,"24":1,"25":1,"26":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"36":1,"37":1,"41":1,"44":1,"45":1,"46":1,"48":1,"51":1,"52":1,"53":1,"54":1,"55":1,"56":1,"57":1,"58":1,"59":1,"61":1,"62":1,"63":1,"65":1,"71":1,"73":1,"74":1,"75":1,"76":1,"77":1,"79":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"buybox~collections~collections-mobile~fulfillment~paint-reorder~paint-reorder-mobile~pep~pep-mobile~~45c9a216","1":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~or~ddb78501","2":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~pa~46fe826e","3":"browse-and-search~browse-and-search-mobile~buybox~collections~collections-mobile~media-gallery-overl~de52b3ab","4":"browse-and-search~browse-and-search-mobile~compare~orange-lens~product-mobile~vendor-collections~ven~4e47053e","5":"media-gallery-filmstrip-mobile~media-gallery-overlay~media-gallery-overlay-mobile~product-mobile","6":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile~write-a-review-form","7":"BuyItAgainTypeaheadPreWrapper","8":"buybox~fulfillment~super-sku","9":"buybox~promotion-products-lazy~quick-view","10":"media-gallery-overlay~media-gallery-overlay-mobile~overlay","11":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","12":"ratings-and-reviews~ratings-and-reviews-mobile~write-a-review-form","13":"add-to-list-drawer~orange-lens","14":"bath-renovation~consumer-card-messaging","15":"compare~orange-lens","16":"media-gallery-overlay~media-gallery-overlay-mobile","18":"StoreLayout","19":"add-to-list-drawer","20":"aisle-bay","21":"augmented-reality","22":"bath-renovation","23":"breadcrumbs","24":"browse-and-search","25":"browse-and-search-mobile","26":"buybox","27":"calculator-pipcalculator","28":"collections","29":"collections-mobile","30":"compare","31":"consumer-card-messaging","32":"customer-image-overlay","33":"drawer","34":"emt-generated-content","35":"emt-links","36":"fulfillment","37":"global-custom-configurator","38":"hammerjs","40":"home","41":"magic-apron","42":"measurement-guide","43":"measurement-guide-overlay-content","44":"media-gallery-filmstrip-mobile","45":"media-gallery-overlay","46":"media-gallery-overlay-mobile","47":"message-types","48":"orange-lens","49":"order-sample","50":"order-sample-drawer","51":"overlay","52":"paint-reorder","53":"paint-reorder-mobile","54":"pep","55":"pep-mobile","56":"product","57":"product-mobile","58":"product-overview","59":"promotion-products-lazy","60":"question","61":"questions-and-answers","62":"quick-view","63":"ratings-and-reviews","64":"ratings-and-reviews-desktop","65":"ratings-and-reviews-mobile","66":"results","67":"returns-messaging","69":"share-to-email-overlay","70":"share-to-pinterest-overlay","71":"size-guide-overlay","72":"specifications","73":"stylequiz","74":"super-sku","75":"vendor-collection-products","76":"vendor-collections","77":"vendor-collections-mobile","79":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"668725f7e6ae2cbf0ccc","3":"83588448fb37280fe4ec","4":"31d6cfe0d16ae931b73c","5":"0ef658ad0521bc70e648","6":"58c38ec3c13b7afd0a80","7":"31d6cfe0d16ae931b73c","8":"370a6ea1c385f9f07fe0","9":"69a26af4764f55edec90","10":"71a6003147651c3739fd","11":"d486fddc1f6d9b29accc","12":"7c2eed0c18c49e42c517","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"9883292c450198dfc0ee","16":"9c6d11fbe8a42a3d0412","17":"65f73a002c9bc45ad240","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"86b1f984e52a6e02026d","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"f5414bab23f5eecead86","25":"aa186598884f4fb51998","26":"2f054b7e61fa0b21c57f","27":"31d6cfe0d16ae931b73c","28":"0d653a2896fd9419628f","29":"0317e1603853ee558731","30":"79724a33b3595b8623f3","31":"a699f2798a275b6729c8","32":"c466036523aec2558c34","33":"fc73174b407ad863c497","34":"b49004ddac99adec2224","35":"31d6cfe0d16ae931b73c","36":"ddf04856a4fe5106f34b","37":"1a5562a08d12f7682989","38":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"ceebf150d8a696023a14","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"c185dd507b97bcc2bd63","45":"e3f49663045d54d118c4","46":"d0c14165bd3e8683e416","47":"31d6cfe0d16ae931b73c","48":"89d9163eeb30e835d559","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"2f7c290bda28b11bb466","52":"fb3b854ecfc223b0a417","53":"b1c3593c1c01221173dc","54":"f23d11de799861a9dc76","55":"1e720f3136683f396e6f","56":"2b67a7eaed08c0d963ee","57":"7e5935ac01230fc86014","58":"be155bb5d11dacdc4bb8","59":"c9964da1755ce9a95535","60":"31d6cfe0d16ae931b73c","61":"d70c859b20e57c1599c5","62":"10bcc289761f77a0ae03","63":"78e5431cefd04f3f0002","64":"31d6cfe0d16ae931b73c","65":"11e50e2b1f3cfc88c5d6","66":"31d6cfe0d16ae931b73c","67":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","70":"31d6cfe0d16ae931b73c","71":"453dfc2640779a848cc6","72":"31d6cfe0d16ae931b73c","73":"f5637400015ba731821d","74":"c391955109f2b07e5d49","75":"e518e335254638969e62","76":"e8cb558ced1f20d7954e","77":"858bff9dfa7d645cbfb7","79":"4a623c3bdc9f1a6eb8a5","80":"31d6cfe0d16ae931b73c","81":"31d6cfe0d16ae931b73c","82":"31d6cfe0d16ae931b73c","83":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.thdstatic.com/experiences/hd-home/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
